import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getLastActivities = createAsyncThunk(
  "LeadSavedSearches/getLastActivities",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_IDX_BASE_URL}api/v1/embedded-app/${data?.site_id}/last-activities`,
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
